export default function hasModule (module, fallback) {
  return ({ next, store, nextVue }) => {
    const isAuthorized = store.getters['client/hasModule'](module);

    if (!isAuthorized) {
      return nextVue({ name: fallback });
    }

    return next();
  };
}
